function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// Adapted from the Uize.Url module, a part of the UIZE JavaScript Framework.
import { encode } from './utils';
var IMMUTABLE_EMPTY_OBJECT = {};
/**
 * Serializes the properties of a params object to produce a URL query string.
 * @param {NullableUrlParams | NullableUrlParams[]} [urlParams] - An object (or array of objects) representing the query
 * @returns {string} Serialized query string
 */

var formatQuery = function formatQuery(urlParams) {
  var paramsObj = urlParams;

  if (Array.isArray(paramsObj)) {
    paramsObj = paramsObj.length < 2 ? paramsObj[0] : Object.assign.apply(Object, [{}].concat(_toConsumableArray(paramsObj)));
  }

  var normalizedParams = paramsObj || IMMUTABLE_EMPTY_OBJECT;
  return Object.keys(normalizedParams).reduce(function (prevUrlParamPairs, paramName) {
    var urlParamPairs = prevUrlParamPairs;
    var paramValue;

    if (paramName) {
      paramValue = normalizedParams[paramName];

      if (paramValue != null) {
        urlParamPairs.push("".concat(encode(paramName), "=").concat(encode(paramValue)));
      }
    }

    return urlParamPairs;
  }, []).join('&');
};

export default formatQuery;